var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
/*!
 * @he-tree/vue v2.2.0
 * Author: phphe <phphe@outlook.com> (https://github.com/phphe)
 * Homepage: https://hetree.phphe.com/
 * Released under the MIT License.
 */
import { defineComponent, computed, watch, reactive, isVue2, isVue3 } from "vue-demi";
import * as hp from "helper-js";
import VirtualList from "@virtual-list/vue/vue2";
import { makeTreeProcessor, CHILDREN } from "@he-tree/tree-utils";
import { extendedDND, context as context$1 } from "@he-tree/dnd-utils";
const cpt$2 = defineComponent({
  props: ["stat", "rtl", "indent", "table", "processor"],
  emits: ["open", "close", "check"],
  setup(props, { emit }) {
    const indentStyle = computed(() => {
      return {
        [!props.rtl ? "paddingLeft" : "paddingRight"]: props.indent * (props.stat.level - 1) + "px"
      };
    });
    watch(() => props.stat.checked, (checked) => {
      if (props.processor.afterOneCheckChanged(props.stat)) {
        emit("check", props.stat);
      }
    });
    watch(() => props.stat.open, (open) => {
      if (open) {
        emit("open", props.stat);
      } else {
        emit("close", props.stat);
      }
    });
    return { indentStyle };
  }
});
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.table ? _c("div", { ref: "el", staticClass: "tree-node", style: _vm.indentStyle }, [_c("div", { staticClass: "tree-node-inner" }, [_vm._t("default", null, { "indentStyle": _vm.indentStyle })], 2)]) : _c("tr", { ref: "el", staticClass: "tree-node" }, [_vm._t("default", null, { "indentStyle": _vm.indentStyle })], 2);
};
var staticRenderFns$1 = [];
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context2) {
      context2 = context2 || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context2 && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context2 = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context2);
      }
      if (context2 && context2._registeredComponents) {
        context2._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context2) {
        hook.call(context2);
        return originalRender(h, context2);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(cpt$2, render$1, staticRenderFns$1, false, __vue2_injectStyles$1, null, null, null);
function __vue2_injectStyles$1(context2) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var TreeNode = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
function vueMakeTreeProcessor(data, options = {}) {
  const opt = __spreadProps(__spreadValues({}, options), {
    statHandler(input) {
      if (this["_statHandler2"]) {
        input = this["_statHandler2"](input);
      }
      return filter(options.statHandler, reactive(input));
    },
    statsHandler(input) {
      return filter(options.statsHandler, reactive(input));
    },
    statsFlatHandler(input) {
      return filter(options.statsFlatHandler, reactive(input));
    }
  });
  return makeTreeProcessor(data, opt);
}
function filter(func, input) {
  return func ? func(input) : input;
}
const cpt$1 = defineComponent({
  components: { VirtualList, TreeNode },
  props: {
    value: { required: isVue2, type: Array },
    modelValue: { required: isVue3, type: Array },
    updateBehavior: {
      type: String,
      default: "modify"
    },
    processor: {
      type: Object,
      default: () => vueMakeTreeProcessor([], {
        noInitialization: true
      })
    },
    childrenKey: { type: String, default: "children" },
    textKey: { type: String, default: "text" },
    indent: { type: Number, default: 20 },
    virtualization: { type: Boolean, default: false },
    virtualizationPrerenderCount: { type: Number, default: 20 },
    defaultOpen: { type: Boolean, default: true },
    statHandler: { type: Function },
    rtl: { type: Boolean, default: false },
    btt: { type: Boolean, default: false },
    table: { type: Boolean, default: false },
    watermark: { type: Boolean, default: true }
  },
  emits: [
    "update:modelValue",
    "click:node",
    "open:node",
    "close:node",
    "check:node",
    "after-drop",
    "change",
    "enter",
    "leave"
  ],
  data() {
    return {
      stats: [],
      statsFlat: [],
      dragNode: null,
      dragOvering: false,
      placeholderData: {},
      placeholderColspan: 1,
      batchUpdateWaiting: false,
      self: this,
      _ignoreValueChangeOnce: false
    };
  },
  computed: {
    valueComputed() {
      return (isVue2 ? this.value : this.modelValue) || [];
    },
    visibleStats() {
      const { statsFlat, isVisible } = this;
      let items = statsFlat;
      if (this.btt) {
        items = items.slice();
        items.reverse();
      }
      return items.filter((stat) => isVisible(stat));
    }
  },
  methods: {
    _emitValue(value) {
      this.$emit(isVue2 ? "input" : "update:modelValue", value);
    },
    _updateValue(value) {
      this._ignoreValueChangeOnce = true;
      if (this.updateBehavior === "disabled") {
        return false;
      }
      this._emitValue(value);
      return true;
    },
    getStat: reactiveFirstArg(processorMethodProxy("getStat")),
    has: reactiveFirstArg(processorMethodProxy("has")),
    updateCheck: processorMethodProxy("updateCheck"),
    getChecked: processorMethodProxy("getChecked"),
    getUnchecked: processorMethodProxy("getUnchecked"),
    openAll: processorMethodProxy("openAll"),
    closeAll: processorMethodProxy("closeAll"),
    isVisible: processorMethodProxy("isVisible"),
    move: processorMethodProxyWithBatchUpdate("move"),
    add: reactiveFirstArg(processorMethodProxyWithBatchUpdate("add")),
    addMulti(dataArr, parent, startIndex) {
      this.batchUpdate(() => {
        let index = startIndex;
        for (const data of dataArr) {
          this.add(data, parent, index);
          if (index != null) {
            index++;
          }
        }
      });
    },
    remove: processorMethodProxy("remove"),
    removeMulti(dataArr) {
      this.batchUpdate(() => {
        for (const data of dataArr) {
          this.remove(data);
        }
      });
    },
    iterateParent: processorMethodProxy("iterateParent"),
    getSiblings: processorMethodProxy("getSiblings"),
    getData: processorMethodProxy("getData"),
    getRootEl() {
      return this.$refs.vtlist.listElRef;
    },
    batchUpdate(task) {
      const r = this.ignoreUpdate(task);
      this._updateValue(this.updateBehavior === "new" ? this.getData() : this.valueComputed);
      return r;
    },
    ignoreUpdate(task) {
      const old = this.batchUpdateWaiting;
      this.batchUpdateWaiting = true;
      const r = task();
      this.batchUpdateWaiting = old;
      return r;
    }
  },
  watch: {
    processor: {
      immediate: true,
      handler(processor) {
        if (processor) {
          const getNodeDataChildren = (nodeData) => {
            if (!nodeData) {
              return this.valueComputed;
            } else {
              const { childrenKey } = this;
              if (!nodeData[childrenKey]) {
                nodeData[childrenKey] = [];
              }
              return nodeData[childrenKey];
            }
          };
          processor["_statHandler2"] = this.statHandler ? (stat) => {
            if (stat.data === this.placeholderData) {
              return stat;
            }
            return this.statHandler(stat);
          } : null;
          processor.afterSetStat = (stat, parent, index) => {
            const { childrenKey, updateBehavior } = this;
            let value = this.valueComputed;
            if (updateBehavior === "new") {
              if (this.batchUpdateWaiting) {
                return;
              }
              value = this.getData();
            } else if (updateBehavior === "modify") {
              const siblings = getNodeDataChildren(parent == null ? void 0 : parent.data);
              if (siblings.includes(stat.data))
                ;
              else {
                siblings.splice(index, 0, stat.data);
              }
            } else
              ;
            if (this.batchUpdateWaiting) {
              return;
            }
            this._updateValue(value);
          };
          processor.afterRemoveStat = (stat) => {
            var _a;
            const { childrenKey, updateBehavior } = this;
            let value = this.valueComputed;
            if (updateBehavior === "new") {
              if (this.batchUpdateWaiting) {
                return;
              }
              value = this.getData();
            } else if (updateBehavior === "modify") {
              const siblings = getNodeDataChildren((_a = stat.parent) == null ? void 0 : _a.data);
              hp.arrayRemove(siblings, stat.data);
            } else
              ;
            if (this.batchUpdateWaiting) {
              return;
            }
            this._updateValue(value);
          };
        }
        if (!processor.initialized) {
          processor.data = this.valueComputed;
          Object.assign(processor, hp.objectOnly(this, ["childrenKey", "defaultOpen"]));
          processor.init();
          processor.updateCheck();
        }
        this.stats = processor.stats;
        this.statsFlat = processor.statsFlat;
        if (processor.data !== this.valueComputed) {
          this._updateValue(processor.data);
        }
      }
    },
    valueComputed: {
      handler(value) {
        if (this._ignoreValueChangeOnce) {
          this._ignoreValueChangeOnce = false;
        } else {
          const { processor } = this;
          processor.data = value;
          processor.init();
          this.stats = processor.stats;
          this.statsFlat = processor.statsFlat;
        }
      }
    }
  },
  created() {
  },
  mounted() {
    if (this.watermark === false) {
      window._heTreeWatermarkDisabled = true;
    }
    if (this.watermark && !window._heTreeWatermarkDisabled) {
      if (!window._heTreeWatermark) {
        window._heTreeWatermark = true;
        console.log(`%c[he-tree] Vue tree component:  https://hetree.phphe.com`, "color:#0075ff; font-size:14px;");
      }
    }
  }
});
function processorMethodProxy(name) {
  return function(...args) {
    return this.processor[name](...args);
  };
}
function processorMethodProxyWithBatchUpdate(name) {
  return function(...args) {
    return this.batchUpdate(() => {
      return this.processor[name](...args);
    });
  };
}
function reactiveFirstArg(func) {
  return function(arg1, ...args) {
    if (arg1) {
      arg1 = reactive(arg1);
    }
    return func.call(this, arg1, ...args);
  };
}
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("VirtualList", { ref: "vtlist", staticClass: "he-tree", class: {
    "he-tree--rtl rtl": _vm.rtl,
    "he-tree--drag-overing drag-overing": _vm.dragOvering
  }, attrs: { "items": _vm.visibleStats, "disabled": !_vm.virtualization, "table": _vm.table }, scopedSlots: _vm._u([{ key: "prepend", fn: function() {
    return [_vm._t("prepend", null, { "tree": _vm.self })];
  }, proxy: true }, { key: "default", fn: function(ref) {
    var stat = ref.item;
    var index = ref.index;
    return [_c("TreeNode", { class: [
      stat.class,
      {
        "drag-placeholder-wrapper": stat.data === _vm.placeholderData,
        "dragging-node": stat === _vm.dragNode
      }
    ], style: stat.style, attrs: { "vt-index": index, "stat": stat, "rtl": _vm.rtl, "indent": _vm.indent, "table": _vm.table, "processor": _vm.processor }, on: { "click": function($event) {
      return _vm.$emit("click:node", stat);
    }, "open": function($event) {
      return _vm.$emit("open:node", $event);
    }, "close": function($event) {
      return _vm.$emit("close:node", $event);
    }, "check": function($event) {
      return _vm.$emit("check:node", $event);
    } }, scopedSlots: _vm._u([{ key: "default", fn: function(ref2) {
      var indentStyle = ref2.indentStyle;
      return [stat.data === _vm.placeholderData ? [!_vm.table ? _c("div", { staticClass: "drag-placeholder he-tree-drag-placeholder" }, [_vm._t("placeholder", null, { "tree": _vm.self })], 2) : _c("td", { style: indentStyle, attrs: { "colspan": _vm.placeholderColspan } }, [_c("div", { staticClass: "drag-placeholder he-tree-drag-placeholder" }, [_vm._t("placeholder", null, { "tree": _vm.self })], 2)])] : _vm._t("default", function() {
        return [_vm._v(_vm._s(stat.data[_vm.textKey]))];
      }, { "node": stat.data, "stat": stat, "indentStyle": indentStyle, "tree": _vm.self })];
    } }], null, true) })];
  } }, { key: "append", fn: function() {
    return [_vm._t("append", null, { "tree": _vm.self })];
  }, proxy: true }], null, true) });
};
var staticRenderFns = [];
var BaseTree_vue_vue_type_style_index_0_lang = "";
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(cpt$1, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context2) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var BaseTree = /* @__PURE__ */ function() {
  return __component__.exports;
}();
let startTree = null;
let targetTree = null;
let startInfo;
let targetInfo;
let dragOpenLastNode;
let startMovePoint;
let startMouse;
let dragNode;
const context = {
  get startInfo() {
    return startInfo;
  },
  get targetInfo() {
    return targetInfo;
  },
  get dragNode() {
    return dragNode;
  },
  get startTree() {
    return startTree;
  },
  get targetTree() {
    return targetTree;
  }
};
const cpt = defineComponent({
  extends: BaseTree,
  props: {
    triggerClass: { type: [String, Array] },
    disableDrag: Boolean,
    disableDrop: Boolean,
    eachDraggable: {
      type: Function
    },
    eachDroppable: {
      type: Function
    },
    rootDroppable: {
      type: [Boolean, Function],
      default: true
    },
    dragOpen: { type: Boolean, default: true },
    dragOpenDelay: { type: Number, default: 0 },
    beforeDragOpen: { type: Function },
    resolveStartMovePoint: {
      type: [String, Function]
    },
    keepPlaceholder: { type: Boolean },
    maxLevel: { type: Number },
    dragCopy: { type: Boolean },
    dragCopyDataHandler: {
      type: Function
    },
    onExternalDragOver: {
      type: Function
    },
    externalDataHandler: {
      type: Function
    }
  },
  data() {
    return {
      treeDraggableInstance: null
    };
  },
  computed: {},
  methods: {
    getNodeByElement(el) {
      const i = el.getAttribute("vt-index");
      return i == null ? null : this.visibleStats[i];
    },
    isDraggable(node) {
      if (this.disableDrag) {
        return false;
      }
      if (node.draggable != null) {
        return node.draggable;
      }
      if (this.eachDraggable) {
        const t = this.eachDraggable(node);
        if (t != null) {
          return t;
        }
      }
      const { parent } = node;
      if (!parent) {
        return true;
      } else {
        return this.isDraggable(parent);
      }
    },
    isDroppable(node) {
      if (this.disableDrop) {
        return false;
      }
      if (!node) {
        return hp.resolveValueOrGettter(this.rootDroppable, [this, startTree]);
      }
      if (node.droppable != null) {
        return node.droppable;
      }
      if (this.eachDroppable) {
        const t = this.eachDroppable(node);
        if (t != null) {
          return t;
        }
      }
      const { parent } = node;
      if (!parent) {
        return true;
      } else {
        return this.isDroppable(parent);
      }
    },
    _eachDroppable() {
      var _a;
      return hp.resolveValueOrGettter((_a = this["_isDragCopy"]) == null ? void 0 : _a.call(this), [this]);
    }
  },
  mounted() {
    const isMoved = (mouse, lastMouse2) => {
      let r = true;
      if (startTree && startTree !== this) {
        r = r && this["_isMoved"];
      }
      if (this.table && !this["_isDragCopy"]) {
        r = r && this["_isDragCopy"];
      }
      return r && (mouse.x !== lastMouse2.x || mouse.y !== lastMouse2.y);
    };
    const movePlaceholder = (parent, index) => {
      targetTree.ignoreUpdate(() => {
        if (!targetTree.has(targetTree.placeholderData)) {
          if (targetTree.table) {
            let colspan = 0;
            const tr = targetTree.getRootEl().querySelector("tr");
            if (tr) {
              for (const {
                value: childEl
              } of hp.iterateAll(tr.children)) {
                if (hp.css(childEl, "display") !== "none") {
                  colspan += childEl.colSpan || 1;
                }
              }
            }
            if (colspan < 1) {
              colspan = 1;
            }
            targetTree.placeholderColspan = colspan;
          }
          targetTree.add(targetTree.placeholderData);
        }
        const placeholder = targetTree.getStat(targetTree.placeholderData);
        targetTree.move(placeholder, parent, index);
      });
    };
    const removePlaceholder = () => {
      const tree = this;
      if (tree.has(tree.placeholderData)) {
        tree.remove(tree.getStat(tree.placeholderData));
        return true;
      }
    };
    const setCursor = (droppable) => {
      if (!droppable) {
        context$1.dropEffect = "none";
      } else {
        context$1.dropEffect = (startTree == null ? void 0 : startTree.dragCopy) ? "copy" : "move";
      }
    };
    const setDroppable = (droppable) => {
      const tree = this;
      if (!droppable) {
        if (!tree.keepPlaceholder) {
          removePlaceholder();
          setCursor(false);
        } else if (!tree.has(tree.placeholderData)) {
          setCursor(false);
        }
      } else {
        setCursor(true);
      }
    };
    let lastMouse = { x: 0, y: 0 };
    const rootEl = this.getRootEl();
    let dragElement = null;
    const removePlaceholderWhenEnd = () => {
      if (targetTree.has(targetTree.placeholderData)) {
        targetTree.ignoreUpdate(() => {
          targetTree.remove(targetTree.getStat(targetTree.placeholderData));
          if (startTree) {
            startTree.dragNode.hidden = false;
            startTree.dragOvering = false;
          }
        });
      }
    };
    this.treeDraggableInstance = extendedDND(rootEl, {
      beforeDragStart: (event) => {
        if (!context$1.triggerElement) {
          return;
        }
        let triggerClass = this.triggerClass;
        if (!triggerClass || triggerClass.length === 0) {
          triggerClass = "tree-node";
        }
        let triggerClasses = hp.toArrayIfNot(triggerClass);
        let triggerDragElement = hp.findParent(context$1.triggerElement, (el) => {
          if (hp.hasClassIn(el, triggerClasses)) {
            return true;
          } else if (hp.hasClass(el, "tree-node")) {
            return "break";
          }
        }, { withSelf: true, until: rootEl });
        dragElement = hp.findParent(triggerDragElement, (el) => {
          if (hp.hasClass(el, "tree-node")) {
            return true;
          }
        }, { withSelf: true, until: rootEl });
        if (!dragElement) {
          return;
        }
        dragNode = this.getNodeByElement(dragElement);
        if (!dragNode) {
          throw `Can't find drag node`;
        }
        if (!this.isDraggable(dragNode)) {
          return;
        }
        return rootEl;
      },
      onDragStart: (event) => {
        var _a, _b;
        if (!dragElement || !dragNode) {
          return;
        }
        {
          const { x, y } = dragElement.getBoundingClientRect();
          const { clientX, clientY } = event;
          (_a = event.dataTransfer) == null ? void 0 : _a.setDragImage(dragElement, clientX - x, clientY - y);
        }
        const mouse = { x: event.clientX, y: event.clientY };
        startMouse = mouse;
        startTree = this;
        startTree.dragNode = dragNode;
        startMovePoint = (() => {
          if (this.resolveStartMovePoint === "mouse") {
            return { x: event.clientX, y: event.clientY };
          } else if (typeof this.resolveStartMovePoint === "function") {
            return this.resolveStartMovePoint(dragElement);
          } else {
            let point;
            let height = 0;
            if (!this.table) {
              if (!this.rtl) {
                point = dragElement.children[0].getBoundingClientRect().toJSON();
                height = point.height;
              } else {
                const rect = dragElement.children[0].getBoundingClientRect();
                point = {
                  x: rect.right,
                  y: rect.y
                };
                height = rect.height;
              }
            } else {
              let rect = dragElement.getBoundingClientRect();
              point = { x: rect.x, y: rect.y };
              if (this.rtl) {
                point.x = rect.right;
              }
              height = rect.height;
            }
            if (this.btt) {
              point.y += height;
            }
            return point;
          }
        })();
        this.dragOvering = true;
        const siblings = startTree.getSiblings(startTree.dragNode);
        const indexBeforeDrop = siblings.indexOf(dragNode);
        startInfo = {
          tree: startTree,
          dragNode,
          parent: dragNode.parent,
          siblings,
          indexBeforeDrop
        };
        targetTree = this;
        (_b = event.dataTransfer) == null ? void 0 : _b.setData("text", `he-tree drag start at ${new Date().toISOString()}`);
        if (!startTree._eachDroppable()) {
          setTimeout(() => {
            dragNode.hidden = true;
            movePlaceholder(dragNode.parent, indexBeforeDrop + 1);
          }, 0);
        }
      },
      onEnter: (event) => {
        this.$emit("enter", event);
      },
      onLeave: (event) => {
        dragOpenLastNode = null;
        this.dragOvering = false;
        context$1.preventDefault = false;
        removePlaceholder();
        this.$emit("leave", event);
      },
      onDragOver: hp.applyFinally((event) => {
        if (!startTree) {
          if (!this.onExternalDragOver || this.onExternalDragOver(event) === false) {
            return;
          } else {
            context$1.preventDefault = true;
          }
        }
        const mouse = { x: event.clientX, y: event.clientY };
        const isMoved2 = isMoved(mouse, lastMouse);
        lastMouse = mouse;
        if (!isMoved2) {
          return;
        }
        this.dragOvering = true;
        targetTree = this;
        const movePoint = startMovePoint ? {
          x: startMovePoint.x + (mouse.x - startMouse.x),
          y: startMovePoint.y + (mouse.y - startMouse.y)
        } : __spreadValues({}, mouse);
        const { btt, rtl } = targetTree;
        if (targetTree.disableDrop) {
          context$1.dropEffect = "none";
          return;
        }
        let prevNode;
        let nextNode;
        const nodeList = targetTree.getRootEl().querySelectorAll(`.tree-node`);
        const nodeEls = [];
        nodeList.forEach((el) => {
          if (!hp.hasClassIn(el, [
            "drag-placeholder-wrapper",
            "dragging-node"
          ]) && hp.css(el, "display") !== "none") {
            nodeEls.push(el);
          }
        });
        const t = hp.binarySearch(nodeEls, (node) => hp.getBoundingClientRect(node)[!btt ? "top" : "bottom"] - movePoint.y, { returnNearestIfNoHit: true });
        let prevIndex = null;
        let prevNodeEl;
        let nextNodeEl;
        if (t.hit)
          ;
        else {
          if (t.greater) {
            if (!btt) {
              prevIndex = t.index - 1;
              if (!nodeEls[prevIndex]) {
                prevIndex++;
              }
            }
          } else {
            if (!btt)
              ;
            else {
              prevIndex = t.index + 1;
              if (!nodeEls[prevIndex]) {
                prevIndex--;
              }
            }
          }
        }
        if (prevIndex == null) {
          prevIndex = t.index;
        }
        prevNodeEl = nodeEls[prevIndex];
        nextNodeEl = !btt ? nodeEls[prevIndex + 1] : nodeEls[prevIndex - 1];
        prevNode = prevNodeEl && targetTree.getNodeByElement(prevNodeEl);
        nextNode = nextNodeEl && targetTree.getNodeByElement(nextNodeEl);
        const { indent } = targetTree;
        const prevBCR = hp.cacheFunction(() => {
          if (!targetTree.table) {
            return hp.getBoundingClientRect(prevNodeEl.firstElementChild);
          } else {
            let r = hp.getBoundingClientRect(prevNodeEl).toJSON();
            const indentSize = indent * (prevNode.level - 1);
            if (!rtl) {
              r.x += indentSize;
            } else {
              r.width -= indentSize;
              r.right -= indentSize;
            }
            return r;
          }
        }).action;
        const onPrevMiddle = hp.cacheFunction(() => {
          if (!btt) {
            return movePoint.y < prevBCR().y + prevBCR().height / 2;
          } else {
            return movePoint.y > prevBCR().y + prevBCR().height / 2;
          }
        }).action;
        const atTop = hp.cacheFunction(() => {
          if (!btt) {
            return !prevNodeEl || prevIndex === 0 && onPrevMiddle();
          } else {
            return !prevNodeEl || prevIndex === nodeEls.length - 1 && onPrevMiddle();
          }
        }).action;
        const prevX_minusMovePointX = hp.cacheFunction(() => !rtl ? prevBCR().x - movePoint.x : movePoint.x - (prevBCR().x + prevBCR().width)).action;
        const atPrevIndentRight = hp.cacheFunction(() => !rtl ? movePoint.x > prevBCR().x + indent : movePoint.x < prevBCR().x + prevBCR().width - indent).action;
        let targetLevel;
        if (atTop()) {
          targetLevel = 1;
          prevNode = null;
        } else if (!prevNode) {
          return;
        } else if (prevX_minusMovePointX() > 0) {
          targetLevel = prevNode.level - Math.ceil(prevX_minusMovePointX() / indent);
        } else if (atPrevIndentRight()) {
          targetLevel = prevNode.level + 1;
        } else {
          targetLevel = prevNode.level;
        }
        if (nextNode && targetLevel < nextNode.level) {
          targetLevel = nextNode.level;
        }
        const findDroppablePosition = async () => {
          let parent, prevSibling;
          let cancelled = false;
          let _dragOpenLastNode = null;
          const isOpen = async (stat) => {
            if (stat.open) {
              return true;
            } else if (targetTree.dragOpen) {
              if (!targetTree.dragOpenDelay) {
                stat.open = true;
                return true;
              } else {
                _dragOpenLastNode = stat;
                if (dragOpenLastNode === stat) {
                  cancelled = true;
                } else {
                  let wait = hp.promisePin();
                  dragOpenLastNode = stat;
                  const localNode = stat;
                  setTimeout(async () => {
                    if (localNode !== dragOpenLastNode) {
                      cancelled = true;
                      wait.resolve(true);
                    } else {
                      if (targetTree.beforeDragOpen) {
                        await targetTree.beforeDragOpen(stat);
                      }
                      if (localNode !== dragOpenLastNode) {
                        cancelled = true;
                        wait.resolve(true);
                      } else {
                        stat.open = true;
                        _dragOpenLastNode = null;
                        wait.resolve(true);
                      }
                    }
                  }, targetTree.dragOpenDelay);
                  return await wait.promise;
                }
              }
            } else {
              return false;
            }
          };
          const tryPrepend = async () => {
            if (targetTree.isDroppable(prevNode) && await isOpen(prevNode)) {
              if (cancelled) {
                return;
              }
              parent = prevNode;
              prevSibling = null;
            } else {
              return false;
            }
          };
          const tryAfter = (minLevel = targetLevel) => {
            let t2 = prevNode;
            let t3 = [];
            while (t2 && t2.level >= minLevel) {
              t2 = t2.parent || null;
              t3.unshift(t2);
            }
            let i = 0;
            for (const node of t3) {
              if (targetTree.isDroppable(node)) {
                parent = node;
                prevSibling = t3[i + 1] || prevNode;
                return true;
              }
              i++;
            }
            return false;
          };
          if (!prevNode) {
            if (targetTree.isDroppable(null)) {
              parent = null;
            }
          } else if (targetLevel > prevNode.level) {
            if (await tryPrepend() === false) {
              tryAfter(prevNode.level);
            }
          } else {
            if (tryAfter() === false) {
              await tryPrepend();
            }
          }
          dragOpenLastNode = _dragOpenLastNode;
          const success = Boolean(!cancelled && (parent || parent === null));
          const getIndex = () => prevSibling ? (parent ? parent.children : targetTree.stats).filter((v) => v.data !== targetTree.placeholderData).indexOf(prevSibling) + 1 : 0;
          return {
            cancelled,
            success,
            parent,
            index: success ? getIndex() : -1
          };
        };
        findDroppablePosition().then((dp) => {
          if (dp.cancelled) {
            return;
          }
          if (!dp.success) {
            setDroppable(false);
            return;
          }
          if (startTree && targetTree.maxLevel != null && targetTree.maxLevel > 0) {
            const dragNode2 = startTree.dragNode;
            let childMaxLevel = 0;
            hp.walkTreeData(dragNode2, (node) => {
              if (node.level > childMaxLevel) {
                childMaxLevel = node.level;
              }
            }, {
              childrenKey: CHILDREN
            });
            const willLevel = childMaxLevel - dragNode2.level + 1 + (dp.parent ? dp.parent.level : 0);
            if (willLevel > targetTree.maxLevel) {
              setDroppable(false);
              return;
            }
          }
          setDroppable(true);
          movePlaceholder(dp.parent, dp.index);
        });
      }, () => {
      }),
      onDrop: (event) => {
        targetTree = this;
        const external = !startTree;
        if (!targetTree) {
          return;
        }
        const dragNode2 = startTree == null ? void 0 : startTree.dragNode;
        let externalData;
        let dragChanged = (() => {
          var _a;
          let changed = true;
          if (!targetTree.has(targetTree.placeholderData)) {
            changed = false;
          } else if (external) {
            externalData = (_a = this.externalDataHandler) == null ? void 0 : _a.call(this, event);
            changed = externalData != null;
          } else if (!startTree.dragCopy) {
            const placeholder = targetTree.getStat(targetTree.placeholderData);
            if (startTree === targetTree && placeholder.parent === dragNode2.parent) {
              if (hp.findTreeData(dragNode2, (node) => node === placeholder), { childrenKey: CHILDREN })
                ;
              else {
                const siblings = this.processor.getSiblings(placeholder);
                const placeholderIndex = siblings.indexOf(placeholder);
                const prev = siblings[placeholderIndex - 1];
                const next = siblings[placeholderIndex + 1];
                if (prev === dragNode2 || next === dragNode2) {
                  changed = false;
                }
              }
            }
          }
          return changed;
        })();
        if (dragChanged) {
          const placeholder = targetTree.getStat(targetTree.placeholderData);
          const siblings = targetTree.getSiblings(placeholder);
          targetInfo = {
            tree: targetTree,
            dragNode: dragNode2,
            parent: placeholder.parent,
            siblings,
            indexBeforeDrop: siblings.indexOf(placeholder)
          };
        }
        (() => {
          removePlaceholderWhenEnd();
          if (dragChanged) {
            let targetIndex = targetInfo.indexBeforeDrop;
            if (startTree && !startTree.dragCopy && startTree === targetTree && startInfo.parent == targetInfo.parent && startInfo.indexBeforeDrop < targetIndex) {
              targetIndex--;
            }
            if (startTree && startTree !== targetTree && !startTree._eachDroppable()) {
              startTree.batchUpdate(() => {
                startTree.remove(dragNode2);
                startTree.updateCheck();
              });
            }
            targetTree.batchUpdate(() => {
              let newDragNode = startTree == null ? void 0 : startTree.dragNode;
              let newData;
              if (externalData) {
                newData = externalData;
              } else if (startTree._eachDroppable()) {
                newData = hp.cloneTreeData(startTree.dragNode.data, {
                  childrenKey: startTree.childrenKey
                });
                if (startTree.dragCopyDataHandler) {
                  newData = startTree.dragCopyDataHandler(newData);
                }
              }
              if (newData) {
                targetTree.add(newData);
                newDragNode = targetTree.getStat(newData);
              }
              targetTree.move(newDragNode, targetInfo.parent, targetIndex);
              targetTree.updateCheck();
            });
          }
          targetTree.$emit("after-drop");
          if (dragChanged) {
            startTree == null ? void 0 : startTree.$emit("change");
            if (targetTree !== startTree) {
              targetTree.$emit("change");
            }
          }
        })();
      },
      onDragEnd: (event) => {
        removePlaceholderWhenEnd();
        if (startTree) {
          startTree.dragNode && (startTree.dragNode.hidden = false);
          startTree.dragNode = null;
          startTree.dragOvering = false;
          startTree = null;
        }
        targetTree = null;
        dragOpenLastNode = null;
        dragNode = null;
      }
    });
  },
  unmounted() {
    var _a;
    (_a = this.treeDraggableInstance) == null ? void 0 : _a.destroy();
  }
});
function pro(account, secretKey) {
  try {
    return {
      mixins: [cpt],
      created: new Function(deSecretKey(account, secretKey))()
    };
  } catch (error) {
    throw new Error("he-tree-pro: wrong secret key");
  }
}
function deSecretKey(account, code) {
  account = encodeURIComponent(account);
  if (account.length % 2 === 1) {
    account += "h";
  }
  account = account.split("").reverse().join("");
  code = atob(code);
  for (let index = 0; index < account.length; index += 2) {
    const a = account[index];
    const b = account[index + 1];
    code = doubleReplace(code, a, b);
  }
  return join2("arb=inowc=ocmet;etrnfucton){are=1,=tistr{evod !=b}ath(){e&(c_htreWtemak=)=e,._sMve=(=>._eteeatrmrkd.israCoy=)=d.abe,._acDrppbl=(=>.dagop)}", code);
}
function doubleReplace(str, char1, char2) {
  let r = "";
  for (let index = 0; index < str.length; index++) {
    const char = str[index];
    if (char === char1) {
      r += char2;
    } else if (char === char2) {
      r += char1;
    } else {
      r += char;
    }
  }
  return r;
}
function join2(a, b) {
  let i = 0;
  let r = "";
  while (true) {
    let index;
    index = i;
    if (index >= b.length) {
      break;
    }
    r += b[index];
    index = i * 2;
    if (index >= a.length) {
      break;
    }
    r += a[index];
    index += 1;
    if (index >= a.length) {
      break;
    }
    r += a[index];
    i++;
  }
  return r;
}
export { BaseTree, cpt as Draggable, context, context as dragContext, pro };
